import { ReactNode } from 'react'
import { Button, Group, IconButton, iconSizes, Table, Text } from '@common/ui'
import { IconChevronDown, IconChevronUp } from '@common/ui/icons'
import classes from './SectionShell.module.css'

type SectionShellProps = {
  title: string
  open: boolean
  onToggleOpen: () => void
  hasFooterToggle: boolean
  footerLabel: string
  ncols: number
  testId: string
  children: ReactNode
}

const SectionShell = ({
  title,
  open,
  onToggleOpen,
  hasFooterToggle,
  footerLabel,
  ncols,
  testId,
  children,
}: SectionShellProps) => (
  <div className={classes.root} data-testid={testId}>
    <Group
      onClick={onToggleOpen}
      data-testid={`${testId}-header`}
      justify="space-between"
      wrap="nowrap"
      className={classes.header}
    >
      <Text fw={600}>{title}</Text>
      <IconButton
        size="sm"
        onClick={(e) => {
          e.stopPropagation()
          onToggleOpen()
        }}
        style={{ color: 'inherit' }}
        aria-label={open ? `Collapse ${title}` : `Expand ${title}`}
        data-testid={`${testId}-header-toggle`}
      >
        {open ? (
          <IconChevronUp size={iconSizes.sm} stroke={1.5} />
        ) : (
          <IconChevronDown size={iconSizes.sm} stroke={1.5} />
        )}
      </IconButton>
    </Group>
    <div className={classes.tableScroll}>
      <Table className={classes.table}>
        {children}
        {hasFooterToggle && (
          <Table.Tbody>
            <Table.Tr>
              <Table.Td colSpan={ncols} className={classes.footerCell}>
                <Button
                  size="xs"
                  variant="subtle"
                  onClick={onToggleOpen}
                  leftSection={
                    open ? (
                      <IconChevronUp size={iconSizes.xs} stroke={1.5} />
                    ) : (
                      <IconChevronDown size={iconSizes.xs} stroke={1.5} />
                    )
                  }
                  data-testid={`${testId}-toggle`}
                >
                  {open ? 'Show less' : footerLabel}
                </Button>
              </Table.Td>
            </Table.Tr>
          </Table.Tbody>
        )}
      </Table>
    </div>
  </div>
)

export default SectionShell
